import {css, useTheme} from "@emotion/react";
import PropTypes from "prop-types";
import {sectionMap} from './SectionWidget';
import { em } from "@util/convertUnits";

const ColumnWidget = ({content}) => {

    const theme = useTheme();

    const columnWrapperCss = css(`
        display:flex;
        flex-direction: column;

        @media (min-width: ${em(theme.breakpoint.ns, 16)}) {
            flex-direction: row;
            justify-content: center;
        }
        
    `)


    const columnCss = css(`
        display: flex;
        justify-content:center;
        align-items:center;
        max-width:30em;
    `)


    const Components = content.content.map(content => {

        const key = JSON.stringify(content);
        const Component = sectionMap[content.type] || null;

        return Component && (
            <div key={key} css={columnWrapperCss}>
                <div key={key} css={columnCss}>
                    <Component content={content}/>
                </div>
            </div>
        )
    })

    return <div>
        {Components}
    </div>;
};

ColumnWidget.propTypes = {
    content: PropTypes.object,
};

export default ColumnWidget;
